var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"d-flex justify-content-between"},[_c('span',{staticClass:"text-light"},[_vm._v(_vm._s(_vm.powered))]),_c('span',{staticClass:"version text-light"},[_c('i',{staticClass:"fa fa-code-branch text-success",attrs:{"aria-hidden":"true"}}),_vm._v("\n      "+_vm._s(_vm.version)+"\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }